import { FaCheck } from 'react-icons/fa';
import Tooltip from 'components/Tooltip';
import styled, { css } from 'styled-components';
import { th, variants } from 'style/theme';

export const Container = styled.div`
  ${variants('size', {
    medium: css`
      margin-bottom: 22px;
    `,
    large: css`
      margin-bottom: 30px;
    `,
    extralarge: css`
      margin-bottom: 40px;
    `
  })}

  position: relative;
  width: 100%;

  :last-of-type {
    margin-bottom: 0;
  }
`;

export const Optional = styled.span`
  font-weight: 400;
  font-size: 14px;
  margin-left: 4px;
`;

export const Error = styled.span`
  margin-left: 5px;
  color: ${th('colors.red')};
  font-weight: 700;
  font-size: 14px;
`;

export const CheckIcon = styled(FaCheck)`
  margin-left: 7px;
  font-size: 14px;
  color: ${th('colors.bermudaGreen')};
`;

export const StyledTooltip = styled(Tooltip)`
  margin-left: 8px;
`;

export const Comment = styled.div`
  font-weight: normal;
  font-size: 15px;
`;
